import * as React from 'react';
const SignOut = (props: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 16 18"
		fill="none"
		{...props}
	>
		<path
			fill="#03488E"
			fillRule="evenodd"
			d="M11 .001a1 1 0 1 1 0 2H2v13a1 1 0 0 0 1 1h8a1 1 0 1 1 0 2H3a3 3 0 0 1-3-3v-14a1 1 0 0 1 1-1h10Zm1.707 5.293A1 1 0 0 0 11 6v2H5a1 1 0 1 0 0 2h6v2a1 1 0 0 0 1.707.707l3-3a1 1 0 0 0 0-1.414l-3-2.999Z"
			clipRule="evenodd"
		/>
	</svg>
);
export default SignOut;
